import { render } from "./DrumVisual.vue?vue&type=template&id=45a0b308"
import script from "./DrumVisual.vue?vue&type=script&lang=js"
export * from "./DrumVisual.vue?vue&type=script&lang=js"

import "./DrumVisual.vue?vue&type=style&index=0&id=45a0b308&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__